import { render } from "./ImageListItem.vue?vue&type=template&id=22449cbc"
import script from "./ImageListItem.vue?vue&type=script&lang=js"
export * from "./ImageListItem.vue?vue&type=script&lang=js"
script.render = render

export default script